const header_nav = () => {
  const prefersFineHover = () =>
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  if (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  ) {
    $("html").addClass("has-touch");
  }

  function closeAllSecondaryMenus() {
    $(".secondary-links .menu-item.menu-item-has-children").removeClass(
      "active-hover"
    );
    $(".secondary-links .menu-item.menu-item-has-children")
      .find(".secondary-sub-menu")
      .hide();
    $(".secondary-links .nav-drop-item").removeClass("aos-animate");
  }

  function closeAllMainMenus() {
    $("#menu-main-menu .menu-item.menu-item-has-children").removeClass(
      "active-hover"
    );
    $("#menu-main-menu .menu-item.menu-item-has-children")
      .find(".sub-menu")
      .hide();
    $(".animated-nav-item").removeClass("aos-animate");
  }

  function openMainMenu($item) {
    closeAllSecondaryMenus();
    closeAllMainMenus();
    $item.addClass("active-hover");
    $item.find(".sub-menu").stop().slideDown();
    setTimeout(() => {
      $(".animated-nav-item").addClass("aos-animate");
    }, 300);
  }

  function closeMainMenu($item) {
    $item.find(".sub-menu").stop().slideUp();
    setTimeout(() => {
      $item.removeClass("active-hover");
    }, 400);
  }

  function toggleMainMenu($item) {
    if ($item.hasClass("active-hover")) {
      closeMainMenu($item);
    } else {
      openMainMenu($item);
    }
  }

  function openSecondaryMenu($item) {
    closeAllMainMenus();
    closeAllSecondaryMenus();
    $item.addClass("active-hover");
    $item.find(".secondary-sub-menu").stop().slideDown();
    setTimeout(() => {
      $(".secondary-links .nav-drop-item").addClass("aos-animate");
    }, 300);
  }

  function closeSecondaryMenu($item) {
    $item.find(".secondary-sub-menu").stop().slideUp();
    setTimeout(() => {
      $item.removeClass("active-hover");
    }, 400);
  }

  function toggleSecondaryMenu($item) {
    if ($item.hasClass("active-hover")) {
      closeSecondaryMenu($item);
    } else {
      openSecondaryMenu($item);
    }
  }

  if (prefersFineHover()) {
    $("#menu-main-menu .menu-item.menu-item-has-children").hover(
      function () {
        openMainMenu($(this));
      },
      function () {
        closeMainMenu($(this));
      }
    );

    $("#menu-main-menu .menu-item.menu-item-has-children").on(
      "touchend",
      function () {
        if ($(this).hasClass("active-hover")) {
          closeMainMenu($(this));
        }
      }
    );

    $("#menu-main-menu .menu-item:not(.menu-item-has-children)").hover(
      function () {
        $(this).addClass("active-hover");
      },
      function () {
        $(this).removeClass("active-hover");
      }
    );

    $(".secondary-links .menu-item.menu-item-has-children").hover(
      function () {
        openSecondaryMenu($(this));
      },
      function () {
        closeSecondaryMenu($(this));
      }
    );

    $(".secondary-links .menu-item:not(.menu-item-has-children)").hover(
      function () {
        $(this).addClass("active-hover");
      },
      function () {
        $(this).removeClass("active-hover");
      }
    );
  } else {
    $("#menu-main-menu .menu-item.menu-item-has-children").on(
      "touchstart",
      function () {
        toggleMainMenu($(this));
      }
    );

    $(".secondary-links .menu-item-has-children > a.nav-main-link").on(
      "click",
      function (e) {
        e.preventDefault();
        toggleSecondaryMenu($(this).parent());
      }
    );
  }

  $("#menu-main-menu > li:not(.menu-item-has-children) > a").on(
    "click",
    function (event) {
      event.preventDefault();

      var href = $(this).data("href");

      if (href) {
        window.location.href = href;
      }
    }
  );
};

export default header_nav;
